/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BellIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABT0lEQVR4nM2Uu0rEUBCGo4WyNoqwhTbiOwjqGwTJXCLMzqxbWG+7jWVKFxZEBHs7O8FK30FrsVRQvLRaKkqOmkVcsjlJCgf+Zjh835nJJQj+S0XUZiB9QtZHYKVa4XHcWUCyZ2T7SONEaIuVwVEUzSDbAFlff+DDuN4gPVMKLiLzwHr5F/w7wHqRnvUWAOv5OHgW0jNfOBWGczZJ5CM4LSE4KS5wr6OfAMkefATv3hOQvRUWeN+ev1IILiKNsgIRaYzjTyDpUVkBkB0nSTKZsxrtlYXj8Avv5e3+trKA9CZvghH/HPNd00ue4LCGFR3kPmVEWwWyfWC79rj1FbDuIdpK4FNE23MRt9cxbnWAtQukOy6sXdeLW2siMhtULQBZDkWaYRhOu4g0Nza3liqDMwHr/YjV3NUmQLb+iL3v1iYQkalUkk7yPU0/7dUmqFKfgFbpzklkIJUAAAAASUVORK5CYII=)
 */
export const BellIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.7 2.89c.18-.07.32-.24.37-.43a2 2 0 0 1 3.86 0c.05.2.19.36.38.43A7 7 0 0 1 19 9.5v2.09c0 .12.05.24.13.33l1.1 1.22a3 3 0 0 1 .77 2.01v.28c0 .67-.34 1.29-.95 1.56-1.31.6-4 1.51-8.05 1.51-4.05 0-6.74-.91-8.05-1.5-.61-.28-.95-.9-.95-1.57v-.28a3 3 0 0 1 .77-2l1.1-1.23a.5.5 0 0 0 .13-.33V9.5a7 7 0 0 1 4.7-6.61ZM9.18 19.84A.16.16 0 0 0 9 20a3 3 0 1 0 6 0c0-.1-.09-.17-.18-.16a24.86 24.86 0 0 1-5.64 0Z"
        className={colorClass}
      />
    </svg>
  );
};
